import React from 'react';
import { motion } from 'framer-motion';

const GlowCard = ({ 
  children, 
  className = '',
  hover = true,
  delay = 0 
}) => {
  const fadeUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-50px" },
    transition: { duration: 0.6, delay }
  };

  return (
    <motion.div
      {...fadeUp}
      className={`
        relative p-6 md:p-8 rounded-2xl
        bg-dark-navy/50 backdrop-blur-sm
        border border-gold/20
        transition-all duration-300
        ${hover ? 'hover:border-gold/40 hover:shadow-lg hover:shadow-gold/20 hover:-translate-y-1' : ''}
        ${className}
      `}
      whileHover={hover ? { scale: 1.02, rotateY: 2 } : {}}
      style={{ transformStyle: 'preserve-3d' }}
    >
      {/* Glow effect */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-gold/0 via-gold/0 to-gold/5 opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
      
      <div className="relative z-10">
        {children}
      </div>
    </motion.div>
  );
};

export default GlowCard;

